module.exports = __webpack_public_path__ + "img/camera.b30d74c9.jpg";